import { Component, Vue } from 'vue-property-decorator';

@Component
export default class InitialChoice extends Vue {

  public partId!: number;

  protected mounted() {
    this.partId = Number(this.$route.params.partId);
  }


  protected onFITTestOrder(): void {
    this.$router.push({
      name: 'inclusion',
      params: {
        screening: this.$route.params.screening,
        partId: String(this.partId),
      },
    });
  }

  protected onRenounce(): void {
    this.$router.push({
      name: 'alternativeQuestionnaire',
      params: {
        screening: this.$route.params.screening,
        partId: String(this.partId),
      },
    });
  }


}

